import {useMoney} from '@shopify/hydrogen';
import type {MoneyV2} from '@shopify/hydrogen/storefront-api-types';

/**
 * A client component that defines the localized value of a product
 */
type Props = {
  money?: MoneyV2 | any;
  className?: string;
  noCode?: boolean;
};

export default function MoneyPrice({money, ...rest}: Props) {
  if (!money) return null;
  const {localizedString, currencyCode} = useMoney(money);
  // check if currency code exists in localizedString
  const hasCurrencyCode = localizedString?.includes(currencyCode);
  return (
    <span {...rest}>
      {localizedString} {!rest?.noCode && !hasCurrencyCode && currencyCode}
    </span>
  );
}
